import { render, staticRenderFns } from "./About.vue?vue&type=template&id=92a5b34c&scoped=true"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"
import style0 from "./About.vue?vue&type=style&index=0&id=92a5b34c&prod&lang=less&scoped=true"
import style1 from "./About.vue?vue&type=style&index=1&id=92a5b34c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92a5b34c",
  null
  
)

export default component.exports